import src from "IMAGE";
export default { src, width: 837, height: 128, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAIkRIcCIkGDASI2VgFMZHEBKDQ4ASIsLwEgKSwBISstZukFrq87ROAAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
